import React from 'react';
import {Redirect} from 'react-router-dom';

import {createRoutes} from '../@crema/utility/Utils';
import {dashBoardConfigs} from './dashboard';
import {errorPagesConfigs} from './errorPages';
import {authRouteConfig} from './auth';
import {managementConfig} from './management';
// import {newsFeedConfig} from './newsFeed';
// import {reportsConfig} from './reports';
import {initialUrl} from '../shared/constants/AppConst';
import {centerConfig} from './centers';

const routeConfigs = [
  ...authRouteConfig,
  ...dashBoardConfigs,
  ...errorPagesConfigs,
  ...managementConfig,
  // ...newsFeedConfig,
  // ...reportsConfig,
  ...centerConfig,
];

const routes = [
  ...createRoutes(routeConfigs),
  {
    path: '/',
    exact: true,
    component: () => <Redirect to={initialUrl} />,
  },
  {
    component: () => <Redirect to='/error-pages/error-404' />,
  },
];

export default routes;
